import FOO01footerLinks from './FOO01-footer-links/FOO01-footer-links';
import VueScrollTo from 'vue-scrollto';
import FOO01FooterCopyright from "./FOO01-footer-copyright/FOO01-footer-copyright";

const HIDE_SCROLLTOP_BUTTON_TIMEOUT_IN_SECONDS = 5;
const SHOW_SCROLLTOP_BUTTON_AFTER_PAGE = 3;

export default {
	components: {
		'foo01-footer-links': FOO01footerLinks,
		'foo01-footer-copyright': FOO01FooterCopyright
	},
	data () {
		return {
			showScrollTop: false,
			fadeOutTimer: null
		};
	},
	methods: {
		scrollTop() {
			VueScrollTo.scrollTo('body', 1000, { offset: 0 });
		},
		handleScroll () {
			let isScrolled = window.scrollY > window.innerWidth * SHOW_SCROLLTOP_BUTTON_AFTER_PAGE;
			const HIDE_SCROLLTOP_BUTTON_TIMEOUT_IN_MILLISECONDS = HIDE_SCROLLTOP_BUTTON_TIMEOUT_IN_SECONDS * 1000;

			clearTimeout(this.fadeOutTimer);

			if (isScrolled) {
				this.showScrollTop = true;
				this.fadeOutTimer = setTimeout(() => {
					this.showScrollTop = false;
				}, HIDE_SCROLLTOP_BUTTON_TIMEOUT_IN_MILLISECONDS);
			} else {
				this.showScrollTop = false;
			}
		}
	},
	created () {
		window.addEventListener('scroll', this.handleScroll);
	},
	destroyed () {
		window.removeEventListener('scroll', this.handleScroll);
	}
}



// WEBPACK FOOTER //
// ../source/modules/FOO01-footer/FOO01-footer.js